export default {
  all: state => Object.keys(state.all).map(key => state.all[key]),
}
